import React from "react";
import { Route, Switch } from 'react-router-dom';  // Enables routing between the components
import Administration from '../../Administration/Administration';
import BuildingInstallation from '../../Administration/Installations/BuildingInstallation';
import ManageSiteLicense from '../../Administration/Licensing/ManageSiteLicense';
import AddModifyUser from '../../Administration/AddModifyUser';
import AddModifyUserSummary from '../../Administration/AddModifyUserSummary';
import ManageUsers from '../../Administration/ManageUsers';
import ChangePassword from '../../../../ChangePassword/ChangePassword';
import AddNewBuilding from '../../Administration/Installations/AddBuilding';
import UserChangeLog from '../../Administration/UserChangeLog';
import GeneralPreferences from '../../UserPreferences/GeneralPreferences';
import EditGeneralPreferences from '../../UserPreferences/EditGeneralPreferences';
import SiteInfo from '../../Administration/SiteDetails';
import SystemStatus from '../../Administration/SystemStatus';
import InvalidLogEntry from "../../Administration/TechnicianHelpScreen/InvalidLogEntry";

  
const AdministrationSubRouting = ({ match }) =>  {
    return (
        <div>
            <Switch>
               <Route path={'/SystemAdmin/Administration'} component={Administration}/>   
               <Route path={'/SystemAdmin/BuildingInstallation'} component={BuildingInstallation}/>   
               <Route path={'/SystemAdmin/ManageSiteLicense'} component={ManageSiteLicense}/>   
               <Route path={'/SystemAdmin/AddModifyUser'} component={AddModifyUser}/>
               <Route path={'/SystemAdmin/AddModifyUserSummary'} component={AddModifyUserSummary}/>   
               <Route path={'/SystemAdmin/ManageUsers'} component={ManageUsers}/>   
               <Route path={'/SystemAdmin/ChangePassword'} component={ChangePassword}/>   
               <Route path={'/SystemAdmin/AddNewBuilding'} component={AddNewBuilding}/>   
               <Route path={'/SystemAdmin/UserChangeLog'} component={UserChangeLog}/>
               <Route path={'/SystemAdmin/GeneralPreferences'} component={GeneralPreferences}/>
               <Route path={'/SystemAdmin/EditGeneralPreferences'} component={EditGeneralPreferences}/>
               <Route path={'/SystemAdmin/SiteInfo'} component={SiteInfo} />
               <Route path={'/SystemAdmin/SystemStatus'} component={SystemStatus}/>
               <Route path={'/SystemAdmin/InvalidLoginLog'} component={InvalidLogEntry}/>
            </Switch>
        </div>  
    );
}

export default AdministrationSubRouting;